import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, FileTextIcon, RotateCcwIcon, DownloadIcon } from 'lucide-react';
interface CompletionProps {
  fileName: string;
  fieldCount: number;
  onStartOver: () => void;
}
export function Completion({
  fileName,
  fieldCount,
  onStartOver
}: CompletionProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="w-full max-w-2xl mx-auto" data-id="element-7">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center" data-id="element-8">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15,
        delay: 0.1
      }} className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-9">
          <CheckCircleIcon className="w-12 h-12 text-green-600" data-id="element-10" />
        </motion.div>

        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-11">All Done!</h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto" data-id="element-12">
          The extracted information has been confirmed and saved successfully.
        </p>

        <div className="bg-gray-50 rounded-lg border border-gray-200 p-5 mb-8 text-left" data-id="element-13">
          <div className="flex items-center gap-3 mb-4" data-id="element-14">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-15">
              <FileTextIcon className="w-5 h-5 text-blue-600" data-id="element-16" />
            </div>
            <div className="min-w-0" data-id="element-17">
              <p className="font-medium text-gray-900 truncate" data-id="element-18">{fileName}</p>
              <p className="text-sm text-gray-500" data-id="element-19">Processed document</p>
            </div>
          </div>
          <div className="flex items-center justify-between pt-4 border-t border-gray-200" data-id="element-20">
            <span className="text-sm text-gray-600" data-id="element-21">
              Fields extracted & saved
            </span>
            <span className="text-sm font-semibold text-gray-900" data-id="element-22">
              {fieldCount}
            </span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3" data-id="element-23">
          <button onClick={onStartOver} className="flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors flex items-center justify-center gap-2" data-id="element-24">
            <RotateCcwIcon className="w-4 h-4" data-id="element-25" />
            Process Another
          </button>
          <button className="flex-1 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2" data-id="element-26">
            <DownloadIcon className="w-4 h-4" data-id="element-27" />
            Download Data
          </button>
        </div>
      </div>
    </motion.div>;
}